export default "__VITE_PUBLIC_ASSET__8f3796db__"